module.exports = __webpack_public_path__ + "static/media/muhammad_atiq.cac49ac4.png";